export const Theme = {
    White: {
        mode: 'light',
        foregroundColor: "text-zinc-900",
        backgroundColor: "bg-white"
    },
    Sky: {
        mode:"light",
        foregroundColor: "text-zinc-900",
        backgroundColor: "bg-blue-300"
    }, 
    Purple: {
        mode:"light",
        foregroundColor: "text-zinc-900",
        backgroundColor: "bg-purple-300"
    },
    Black: {
        mode:"dark",
        foregroundColor: "text-white",
        backgroundColor: "bg-black"
    },
    Teal: {
        mode:"dark",
        foregroundColor: "text-white",
        backgroundColor: "bg-teal-900"
    },
    Pink: {
        mode:"dark",
        foregroundColor: "text-white",
        backgroundColor: "bg-pink-500"
    },
    Amber: {
        mode:"dark",
        foregroundColor: "text-white",
        backgroundColor: "bg-amber-900"
    },
    Emerald: {
        mode:"dark",
        foregroundColor: "text-white",
        backgroundColor: "bg-emerald-900"
    },
    Blue: {
        mode:"dark",
        foregroundColor: "text-white",
        backgroundColor: "bg-sky-900"
    },
    Indigo: {
        mode:"dark",
        foregroundColor: "text-zinc-900",
        backgroundColor: "bg-indigo-300"
    },
    Violet: {
        mode:"dark",
        foregroundColor: "text-white",
        backgroundColor: "bg-violet-900"
    },
    Fuchsia: {
        mode:"dark",
        foregroundColor: "text-white",
        backgroundColor: "bg-fuchsia-900"
    },
    Rose: {
        mode:"dark",
        foregroundColor: "text-white",
        backgroundColor: "bg-rose-900"
    },
    Lime: {
        mode:"dark",
        foregroundColor: "text-white",
        backgroundColor: "bg-lime-900"
    },

    
}